require('../src/bootstrap');
require('../src/directives');
require('./components');

import Gtag from "../src/core/Gtag";
import Form from './../src/core/Form';
import Slider from './../src/core/Slider';
import Header from './../src/core/Header';
import Gallery from './../src/core/Gallery';
import Navigation from './../src/core/Navigation';
import DropUpload from './../src/core/DropUpload';

new Vue({
    el: '#app',
    data: {
        bodyClass: null
    },
    mounted() {
        document.body.addEventListener('click', event => EventHandler.fire('body-clicked', event));
        new Form;
        new Gtag;
        new Slider;
        new Header;
        new Gallery;
        new Navigation;
        new DropUpload;
        window.addEventListener('scroll', event => {
            if (window.pageYOffset > 120) {
                this.bodyClass = 'stick';
            } else {
                this.bodyClass = null;
            }
        });
    }
});